/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Intro_EyebrowInputs */

const es_l6_intro_eyebrow = /** @type {(inputs: L6_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para operadores`)
};

const gl_l6_intro_eyebrow = /** @type {(inputs: L6_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para operadores`)
};

const en_l6_intro_eyebrow = /** @type {(inputs: L6_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For operators`)
};

/**
* | output |
* | --- |
* | "For operators" |
*
* @param {L6_Intro_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_intro_eyebrow = /** @type {((inputs?: L6_Intro_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Intro_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_intro_eyebrow(inputs)
	if (locale === "en") return en_l6_intro_eyebrow(inputs)
	return es_l6_intro_eyebrow(inputs)
});